import { getSelectedGroupDetails } from '@/components/forms/utils/workflowContext';

import { WorkflowGroup } from '@/components/forms/components/ui/workflowGroup/workflowGroup';

import { WidgetWriterProps } from '@/components/forms/components/form/writer/widgets/widget.type';

export const GroupWidget = ({
  label = '',
  value = '',
  name,
  formContext
}: WidgetWriterProps) => {
  const selectedGroup = getSelectedGroupDetails(
    formContext?.workflowContext,
    value
  );

  return (
    <>
      <div
        className="mb-[3px] text-base font-semibold"
        data-testid="reader-group-label"
        data-cy={`reader-group-label-${name}`}
      >
        {label}
      </div>
      <div
        className="text-foreground flex text-sm"
        data-testid="reader-group-info"
        data-cy={`reader-group-info-${name}`}
      >
        {selectedGroup ? (
          <WorkflowGroup
            name={selectedGroup.name || value}
            avatar={selectedGroup.avatar}
          />
        ) : (
          value
        )}
      </div>
    </>
  );
};
